import { render, staticRenderFns } from "./detail-tab-sentimento.vue?vue&type=template&id=50992a52&scoped=true&"
import script from "./detail-tab-sentimento.vue?vue&type=script&lang=js&"
export * from "./detail-tab-sentimento.vue?vue&type=script&lang=js&"
import style0 from "./detail-tab-sentimento.vue?vue&type=style&index=0&id=50992a52&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50992a52",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50992a52')) {
      api.createRecord('50992a52', component.options)
    } else {
      api.reload('50992a52', component.options)
    }
    module.hot.accept("./detail-tab-sentimento.vue?vue&type=template&id=50992a52&scoped=true&", function () {
      api.rerender('50992a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/detail-tab-sentimento/detail-tab-sentimento.vue"
export default component.exports